export default __webpack_public_path__ + "static/montserrat-v18-latin-700-686bda13a6c973520c205d18ad0c404d.woff2";